export default __webpack_public_path__ + "static/media/yellow-arrow-left_1.955cfb46.svg";